import { useQuery } from '@tanstack/react-query'
import { settingsApi, type FeatureFlags } from '@/lib/api'

/**
 * Shared hook for feature flags. Replaces duplicated inline useQuery calls
 * Used by FeatureGuard and sidebar visibility.
 *
 * Backend returns flat-merged: {success, message, enable_tasks, ...}
 * After the response interceptor: res.data = same flat shape.
 */
export function useFeatureFlags() {
  return useQuery<FeatureFlags>({
    queryKey: ['feature-flags'],
    queryFn: async () => {
      const res = await settingsApi.getFeatures()
      return res.data as FeatureFlags
    },
    staleTime: 60_000,
  })
}
